import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
export function AudienceSection() {
  const isFor = ['Women 40+ in peri- or menopause dealing with "Stress Belly."', 'Women who feel like their stomach bloats just by "looking at food."', 'Women who suffer from insomnia or wake up feeling unrefreshed every morning.', 'Anyone who hates restrictive diets and extreme gym workouts.'];
  const isNotFor = ['Women looking for a "magic pill" without changing their nighttime light and rest habits.', 'Men or women under 25 (their hormones operate under different biological rules).', 'Anyone unwilling to dedicate 7 minutes to their nightly health ritual.'];
  return <section className="bg-white pt-12 pb-10" data-id="element-13">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-16" data-id="element-15">
          {/* Who this is for */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-cream/30 p-8 rounded-3xl border border-cream" data-id="element-16">
            <h3 className="text-2xl font-bold mb-8 flex items-center gap-3" data-id="element-17">
              <span className="bg-deep-teal/10 text-deep-teal p-2 rounded-lg" data-id="element-18">
                <CheckIcon className="w-6 h-6" data-id="element-19" />
              </span>
              Who This Is For
            </h3>
            <ul className="space-y-6" data-id="element-20">
              {isFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-21">
                  <CheckIcon className="w-6 h-6 text-deep-teal flex-shrink-0 mt-0.5" data-id="element-22" />
                  <span className="text-gray-700 text-lg" data-id="element-23">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Who this is not for */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gray-50 p-8 rounded-3xl border border-gray-100" data-id="element-24">
            <h3 className="text-2xl font-bold mb-8 flex items-center gap-3" data-id="element-25">
              <span className="bg-emergency-red/10 text-emergency-red p-2 rounded-lg" data-id="element-26">
                <XIcon className="w-6 h-6" data-id="element-27" />
              </span>
              Who This Is NOT For
            </h3>
            <ul className="space-y-6" data-id="element-28">
              {isNotFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-29">
                  <XIcon className="w-6 h-6 text-emergency-red flex-shrink-0 mt-0.5" data-id="element-30" />
                  <span className="text-gray-600 text-lg" data-id="element-31">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}